import React from 'react';
import WHStep5 from './WHStep5';

export default function WHStep5Container({ formikProp }) {
  return <WHStep5 formikProp={formikProp} />;
}
